export class AppSettings {
    public static API_URI_PUBLIC = '/homebox-public/api';
}